import { Routes } from "@angular/router";
import { EAccessType } from "@app/shared/authentication/enums/access-type.enum";
import { accessTokenGuard } from "@app/shared/authentication/guards/access-token.guard";
import { guestGuard } from "@app/shared/authentication/guards/guest.guard";

export const authenticationRoutes: Routes = [
  {
    path: "login",
    loadComponent: () => import("./domains/login/pages/login/login.component").then(c => c.LoginComponent),
    canActivate: [guestGuard],
  },
  {
    path: "forget-password",
    loadComponent: () => import("./domains/forget-password/pages/forget-password/forget-password.component").then(c => c.ForgetPasswordComponent),
    canActivate: [guestGuard],
  },
  {
    path: "register",
    loadComponent: () => import("./domains/register/pages/register/register.component").then(c => c.RegisterComponent),
    canActivate: [guestGuard],
  },
  {
    path: "verify-otp",
    loadComponent: () =>
      import("@app/applications/authentication/domains/register/pages/verify-otp/verify-otp.component").then(c => c.VerifyOtpComponent),
    canActivate: [accessTokenGuard],
    data: {
      allowedAccessToken: EAccessType.CONFIRM_EMAIL,
    },
  },
  {
    path: "new-password",
    loadComponent: () =>
      import("@app/applications/authentication/domains/forget-password/pages/new-password/new-password.component").then(c => c.NewPasswordComponent),
    canActivate: [accessTokenGuard],
    data: {
      allowedAccessToken: EAccessType.CONFIRM_RESET_PASSWORD,
    },
  },
  {
    path: "verify-forget-password-otp",
    loadComponent: () =>
      import("@app/applications/authentication/domains/forget-password/pages/verify-forget-password-otp/verify-forget-password-otp.component").then(
        c => c.VerifyForgetPasswordOtpComponent
      ),
    canActivate: [accessTokenGuard],
    data: {
      allowedAccessToken: EAccessType.VERIFY_RESET_PASSWORD,
    },
  },
];
